import { render, staticRenderFns } from "./hCaptcha.vue?vue&type=template&id=2325a47e&"
import script from "./hCaptcha.vue?vue&type=script&lang=js&"
export * from "./hCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2325a47e')) {
      api.createRecord('2325a47e', component.options)
    } else {
      api.reload('2325a47e', component.options)
    }
    module.hot.accept("./hCaptcha.vue?vue&type=template&id=2325a47e&", function () {
      api.rerender('2325a47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/hCaptcha.vue"
export default component.exports